<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0">
      <label>VENCIMENTO</label>
      <input type="date" class="form-control" v-model="due_date" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <label>VALOR</label>
      <input
        type="text"
        class="form-control"
        v-model="value"
        @input="handleInputItemValue($event.target.value)"
      />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <label>OBSERVAÇÃO</label>
      <ChromeSpeechToTextTextarea rows="3" v-model="note" />
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <v-btn class="btn-cancel" @click="$bvModal.hide(`edit-item-${item.id}`)"
        ><i class="fas fa-times mr-2 text-twenty"></i>CANCELAR</v-btn
      >
    </div>
    <div class="col-md-6 pt-0 pb-0 text-right">
      <v-btn :disabled="loading" @click="update()" class="btn-save">
        <i class="fas fa-check mr-2 text-twenty"></i>
        {{ loading ? "CARREGANDO" : "SALVAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { formatValueOnKeyUp, numbersOnly } from "../../../../lib/format";

import moment from "moment";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
  },

  data() {
    return {
      due_date: "",
      value: "",
      note: "",

      loading: false,

      errors: [],
    };
  },

  props: {
    item: Object,
  },

  created() {
    let {
      item: { due_date, value, note },
    } = this;

    this.note = note;
    this.due_date = moment(due_date).format("YYYY-MM-DD");
    this.value = formatValueOnKeyUp(numbersOnly(value.toFixed(2)));
  },

  methods: {
    formatValueOnKeyUp,
    numbersOnly,
    moment,

    handleInputItemValue(value) {
      this.value = formatValueOnKeyUp(numbersOnly(value));
    },

    async update() {
      try {
        this.loading = true;

        let {
          item: { id },
          due_date,
          value,
          note,
        } = this;

        let params = {
          id,
          note,
          due_date,
          value,
        };

        const response = await api.patch(
          "/rest-home/resident-accommodation-item",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`edit-item-${id}`);
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
